import React from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { defaults } from 'chart.js';
import './index.css';
import App from './App';
import { ThemeModeProvider, useThemeMode } from './ThemeContext';
import { createAppTheme } from './theme';

defaults.color = '#94a3b8';
defaults.borderColor = 'rgba(255,255,255,0.08)';
defaults.scale.grid.color = 'rgba(255,255,255,0.06)';
defaults.scale.ticks.color = '#94a3b8';

function ThemedApp() {
  const { isDark } = useThemeMode();
  return (
    <ThemeProvider theme={createAppTheme(isDark)}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  </React.StrictMode>
);
